import React from 'react';
import { CheckIcon, LockKeyholeIcon, ShieldCheckIcon, SmartphoneIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { checkoutUrl, price } from '../data/product';
const rows: Array<[string, string]> = [['Hours lost programming every session from scratch', '60+ ready-to-coach sessions to adapt to your floor'], ['The same tired circuits on repeat', '150+ exercises and fresh sequences'], ['Mixed-level groups hard to manage', 'Clear scaling for every level'], ['Uncertainty with back-pain or pre-natal clients', 'Clinical protocols and special populations'], ['Walking in without a plan', '6 volumes to coach with a real method']];
const assurances = [{
  icon: LockKeyholeIcon,
  label: 'Secure payment'
}, {
  icon: SmartphoneIcon,
  label: 'Smartphone & tablet optimized'
}, {
  icon: ShieldCheckIcon,
  label: '7-day guarantee'
}];
export function FinalCTA() {
  return <section className="bg-ink-900 px-5 py-20" data-id="element-35" data-mp="zua64uzega7d">
      <div className="mx-auto max-w-3xl text-center" data-id="element-36" data-mp="2c5g6g6d0l2vy">
        <h2 className="font-display text-[2.3rem] font-semibold uppercase leading-[1] tracking-[.01em] text-white sm:text-5xl" data-id="element-37" data-mp="2c6r6pw793sib">
          Stop improvising.
          <span className="block font-medium normal-case italic tracking-normal text-clay-300" data-id="element-38" data-mp="2m1sw8t5fuwlf">
            Start coaching with a system.
          </span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl leading-relaxed text-stone-300" data-id="element-39" data-mp="2v3sefos6w6py">
          Join 1,500+ elite coaches who plan their entire year of functional
          training in under 5 minutes.
        </p>
        <div className="mt-11 overflow-hidden border border-white/15 text-left" data-id="element-40" data-mp="34sshbj9tbm9f">
          <div className="grid grid-cols-2 bg-ink-800 text-center text-[10px] font-semibold uppercase tracking-[.18em]" data-id="element-41" data-mp="39sf52mn9okwh">
            <p className="p-4 text-stone-300" data-id="element-42" data-mp="3es1hwuz6nz4r">Without Functional Ready</p>
            <p className="border-l border-white/15 p-4 text-clay-300" data-id="element-43" data-mp="3it39qqqrt8wp">
              With Functional Ready
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-white/10 text-xs sm:text-sm" data-id="element-44" data-mp="1jlz448eudtqk">
              <p className="p-4 text-stone-300" data-id="element-45" data-mp="1shoxp4qg1uf1">{without}</p>
              <p className="flex gap-2 border-l border-white/10 bg-white/[.04] p-4 font-medium text-white" data-id="element-46" data-mp="1npyhwj8qmeg8">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-clay-300" data-id="element-47" data-mp="22ekvogipuy5c" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-10" data-id="element-48" data-mp="1xhuhjyqh2cmk">
          <CountdownTimer dark data-id="element-49" data-mp="2bf99pb840yi8" />
        </div>
        <div className="border border-white/15 bg-ink-800 p-7 text-left" data-id="element-50" data-mp="2bezjbmj5kpc0">
          <p className="text-[11px] font-semibold uppercase tracking-[.2em] text-clay-300" data-id="element-51" data-mp="27do3g8q2zih0">
            The complete system
          </p>
          <h3 className="mt-2 font-display text-2xl font-semibold text-white" data-id="element-52" data-mp="h1rvwfxibg0e">
            Functional Ready™ — 6 volumes + 5 bonuses
          </h3>
          <div className="mt-6 flex items-end justify-between gap-4" data-id="element-53" data-mp="2vg7py3oil9b">
            <div data-id="element-54" data-mp="2yc61njfvbya">
              <p className="text-sm text-stone-300 line-through" data-id="element-55" data-mp="6xbhlqzoe6yp">
                {price.total}
              </p>
              <p className="font-display text-5xl font-semibold leading-none text-white" data-id="element-56" data-mp="3pccc8v8kfh3x">
                {price.current}
              </p>
            </div>
            <p className="bg-sage-600 px-3 py-2 text-[11px] font-semibold uppercase tracking-[.16em] text-white" data-id="element-57" data-mp="3u8atlyvh7yuu">
              Save {price.savings}
            </p>
          </div>
        </div>
        <a href={checkoutUrl} className="cta-button mt-8 block w-full px-6 py-5 text-base font-bold uppercase tracking-[.06em] sm:text-lg" data-id="element-58" data-mp="3kad83j504g5x">
          Download the complete system for {price.current}
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs font-medium text-stone-300" data-id="element-59" data-mp="14ksd964f0787">
          {assurances.map(({
          icon: Icon,
          label
        }) => <span key={label} className="flex items-center gap-1.5" data-id="element-60" data-mp="19i28j2ehjd3y">
              <Icon className="h-4 w-4 text-clay-300" data-id="element-61" data-mp="35n1bj5qz895e" />
              {label}
            </span>)}
        </div>
      </div>
    </section>;
}